import React from 'react'
import { Box, Paper, Stack, Container, Typography } from '@mui/material'

type Props = {
  title: string
  children: React.ReactNode
  backgroundImageUrl?: string
}

export const AuthLayout: React.FC<Props> = ({ title, children, backgroundImageUrl }) => (
  <Box
    sx={{
      position: 'relative',
      height: '100vh',
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '50%',
        backgroundImage: `url(${backgroundImageUrl || '/login.jpg'})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        zIndex: -1,
      }}
    />
    <Container maxWidth="sm">
      <Stack
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Paper
          sx={{
            textAlign: 'center',
            p: '24px',
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              fontWeight: 'bold',
            }}
          >
            {title}
          </Typography>
          {children}
        </Paper>
      </Stack>
    </Container>
  </Box>
)

export default AuthLayout
